export default __webpack_public_path__ + "static/media/151-metallic-blind.cd5ec181.png";